import React from "react";
import "../Styles/LifestyleHabits.css";

const LifestyleHabits = ({
  habitList,
  hobbiesList,
  selectedHabits,
  setSelectedHabits,
  selectedHobbies,
  setSelectedHobbies,
}) => {
  const toggleSelection = (id, list, setList) => {
    if (list.includes(id)) {
      setList(list.filter((item) => item !== id));
    } else {
      setList([...list, id]);
    }
  };

  const renderhabitListOptions = () => {
    return habitList.map((item) => (
      <button
        key={item.HabitId}
        className={`option-btn ${selectedHabits.includes(item.HabitId) ? "selected" : ""} click-effect`}
        onClick={() => toggleSelection(item.HabitId, selectedHabits, setSelectedHabits)}
      >
        {item.HabitsName}
      </button>
    ));
  };

  const renderhobbiesListOptions = () => {
    return hobbiesList.map((item) => (
      <button
        key={item.HobbiesId}
        className={`option-btn ${selectedHobbies.includes(item.HobbiesId) ? "selected" : ""} click-effect`}
        onClick={() => toggleSelection(item.HobbiesId, selectedHobbies, setSelectedHobbies)}
      >
        {item.HobbieName}
      </button>
    ));
  };

  return (
    <div className="container-1 p-4 mt-4 mb-4">
      <h2 className="section-title">Lifestyle & Habits</h2>

      <div className="section-group">
        <h4 className="subheading">Habits</h4>
        <div className="button-group">{renderhabitListOptions()}</div>
      </div>

      <div className="section-group">
        <h4 className="subheading">Hobbies and interests</h4>
        <div className="button-group">{renderhobbiesListOptions()}</div>
      </div>
    </div>
  );
};

export default LifestyleHabits;
